<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/logs:offline-log.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          @clickedButton1="showJson"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="wentDarkAfter"
          sort-desc
          :customPanel="createPanel()"
          @cacheCommit="$store.commit('display/logs/logsSearchUpdate', {searchTerm:$event, searchType: 'offline'})"
          :cachedSearch="$store.state.display.logs.offlineLogsSearch"
        />

      </v-col>
    </v-row>
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import LogsService from '@/modules/display/services/logs-service';
import TablePanel from "@/modules/display/views/logs/TablePanel";
import DataUtils from '@/modules/core/services/data-utils';
import Log from "@/modules/display/data/log";
import Utils from '@/modules/core/services/utils';
import Vue from "vue";
import {i18n} from '@/plugins/i18next';

export default {
  name: "OfflineTable",
  components: {
    DataTablePaginated
  },
  data() {
    return {
      filterHours: true
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('display/logs:offline-log.elevator-id'), value: 'elevatorId' },
        { text: this.$t('common:name'), value: 'elevatorName' },
        { text: this.$t('display/logs:offline-log.went-dark'), value: 'wentDarkAfter' },
        { text: this.$t('display/logs:offline-log.came-back'), value: 'cameBackAt' },
        { text: this.$t('display/logs:offline-log.message-generated'), value: 'messageGeneratedAt' },
        { text: this.$t('display/logs:offline-log.offline-duration'), value: 'duration' }
      ]
    }
  },
  methods: {
    showJson(item) {
      this.$refs.dialogShow.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;
      let filter = {filter24: this.filterHours};

      LogsService.readAllLogsPaginated(
        'offline',
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        filter,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Log);
            for (let i = 0; i < response.data.content.length; i++) {
              response.data.content[i].id = i;
              response.data.content[i].duration = this.millisToMinutesAndSeconds(response.data.content[i].offlineDuration);
            }
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:alive.alive-log-table')}));
        }
      );
    },
    millisToMinutesAndSeconds(millis) {
      if (!millis) {
        return '';
      }

      let minutes = Math.floor(millis / 60000);
      let seconds = ((millis % 60000) / 1000).toFixed(0);
      return (seconds == 60 ? (minutes + 1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: {filterValue: this.filterHours}
      });
      instance.$on('customPanelValueUpdated', this.updateFilter);
      return instance;
    },
    updateFilter(value) {
      this.filterHours = value;
      this.$refs.table.callTableUpdate()
    }
  }
}
</script>
